import { hasYesOrNo } from 'models/validate';
import militaryHistoryItemValidator from 'forms/sections/military/history/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { DeepSafePartial } from 'types/types';
import { MilitaryHistoryModel } from './types';

type Attributes = DeepSafePartial<MilitaryHistoryModel>;

const militaryHistoryValidator: ValidateJSModel<MilitaryHistoryModel> = {
  HasServed: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },

  HasServedMerchantMarine: (value, attributes, attributeName, options) => {
    if (options?.requireMilitaryHasServedMerchantMarine === false) { return {}; }

    return {
      hasValue: { validator: hasYesOrNo },
    };
  },

  List: (value, attributes: Attributes) => {
    if (
      attributes?.HasServed?.value === 'Yes'
      || attributes?.HasServedMerchantMarine?.value === 'Yes'
    ) {
      return {
        presence: true,
        accordion: { validator: militaryHistoryItemValidator },
      };
    }

    return {};
  },

  Comments: {},
  SummaryComments: {},
};

export default militaryHistoryValidator;
